const decodeHTML = (html: string): string => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(
    `<!doctype html><body>${html}`,
    'text/html'
  );
  return dom.body.textContent ?? '_null';
};

export default decodeHTML;
